import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';
import useFetchGlobalConfig from '@nike/shop-apis/global-config/use-query';
import useFetchIdentity from '@nike/shop-apis/identity/web-shell-client/use-query';
import getCheckoutHref from '@nike/shop-apis/utils/get-checkout-href';
import { ButtonStyled } from '@nike/nike-design-system-components';
import trackEvent from "../../analytics/track-event";
import checkoutClickEvent from "../../analytics/checkout-click-event";
import { CHECKOUT_INTENT_START } from "../../analytics/constants";
var CheckoutButton = function CheckoutButton(t0) {
  var $ = _c(20);
  var children = t0.children,
    t1 = t0.appearance,
    onClickProp = t0.onClick;
  var appearance = t1 === undefined ? "primary" : t1;
  var _useFetchGlobalConfig = useFetchGlobalConfig(),
    data = _useFetchGlobalConfig.data;
  var _ref = data || {},
    isGlobalStoreCountry = _ref.isGlobalStoreCountry;
  var queryClient = useQueryClient();
  var t2;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      select: _temp
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  var _useFetchIdentity = useFetchIdentity(t2),
    isLoggedIn_0 = _useFetchIdentity.data;
  var trackCartItemClick = _temp2;
  var t3;
  if ($[1] !== isLoggedIn_0) {
    t3 = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var eventData;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              eventData = checkoutClickEvent({
                checkoutType: isLoggedIn_0 ? "registered" : "guest"
              });
              _context.next = 1;
              return trackCartItemClick();
            case 1:
              trackEvent(CHECKOUT_INTENT_START, eventData);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function t3() {
        return _ref2.apply(this, arguments);
      };
    }();
    $[1] = isLoggedIn_0;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  var handleCheckoutClickEvent = t3;
  var t4;
  if ($[3] !== handleCheckoutClickEvent || $[4] !== onClickProp) {
    var handleGSCheckout = function handleGSCheckout(e) {
      e.preventDefault();
      onClickProp === null || onClickProp === void 0 || onClickProp(e);
      handleCheckoutClickEvent();
      return window.NikeShop.navigateToCheckout({
        redirectToCheckout: false
      });
    };
    t4 = {
      Component: "button",
      onClick: handleGSCheckout
    };
    $[3] = handleCheckoutClickEvent;
    $[4] = onClickProp;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  var globalStoreCheckoutProps = t4;
  var t5;
  if ($[6] !== isLoggedIn_0 || $[7] !== queryClient) {
    t5 = getCheckoutHref({
      queryClient: queryClient,
      isLoggedIn: isLoggedIn_0
    });
    $[6] = isLoggedIn_0;
    $[7] = queryClient;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  var t6;
  if ($[9] !== handleCheckoutClickEvent || $[10] !== onClickProp) {
    t6 = function t6(e_0) {
      onClickProp === null || onClickProp === void 0 || onClickProp(e_0);
      handleCheckoutClickEvent();
    };
    $[9] = handleCheckoutClickEvent;
    $[10] = onClickProp;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  var t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = {
      href: t5,
      Component: "a",
      onClick: t6
    };
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  var nonGlobalStoreCheckoutProps = t7;
  var t8 = isLoggedIn_0 ? "member-checkout-button" : "guest-checkout-button";
  var t9 = isGlobalStoreCountry ? globalStoreCheckoutProps : nonGlobalStoreCheckoutProps;
  var t10;
  if ($[15] !== appearance || $[16] !== children || $[17] !== t8 || $[18] !== t9) {
    t10 = /*#__PURE__*/React.createElement(ButtonStyled, _extends({
      "data-automation": t8,
      size: "large"
    }, t9, {
      appearance: appearance
    }), children);
    $[15] = appearance;
    $[16] = children;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
CheckoutButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  appearance: PropTypes.string,
  onClick: PropTypes.func
};
export default CheckoutButton;
function _temp(t0) {
  var isLoggedIn = t0.isLoggedIn;
  return isLoggedIn;
}
function _temp2() {
  return _temp3.apply(this, arguments);
}
function _temp3() {
  _temp3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var clickableItemEnums;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return window.webShellClient.analytics.utils.getProtoEnums("Cart_ClickableItem_v2");
        case 1:
          clickableItemEnums = _context2.sent;
          window.webShellClient.analytics.trackAction({
            underlyingAction: {
              "case": "uxCommerceCartV2ItemClicked",
              value: {
                item: clickableItemEnums.CHECKOUT_BUTTON
              }
            }
          }, {
            eventVersion: 2
          });
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _temp3.apply(this, arguments);
}